<mat-card>
  <mat-card-header>
    <h1 mat-card-title>{{ 'Create_Account_tr' | translate }}</h1>
  </mat-card-header>

  <mat-card-content>
    @if (showV2Fallback) {
      <app-recaptcha-v2-fallback (solved)="onV2Solved($event)" />
    }
  </mat-card-content>

  <mat-card-actions>
    <a [routerLink]="['/login']">
      {{ 'back_to_login_page_tr' | translate }}
    </a>
  </mat-card-actions>
</mat-card>
